/* eslint-disable jsx-a11y/no-static-element-interactions */
// @flow
import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { Modal, Toast } from '@ifchange-eui-mobile/eui-mobile'
import PropTypes from 'prop-types'
import { container } from '@landrover/business/index'
import { encodeUrlSearch } from '@utils/unit'
import { userLogout } from '@stores/actions/users'
import Button from '../Button'
import Icon from '../Icon'
import defaultHead from './default.png'
import './mine.scss'

function Mine (props) {
  const { history, onClose, logout, users = {}, companyInfo = {} } = props
  const [acount, setAcount] = useState('')
  const [menus, setMenus] = useState([])
  const [visible, setVisible] = useState(false)
  const [isLogin, setIsLogin] = useState(false)

  useEffect(() => {
    if (users.token) {
      setIsLogin(true)
    }
  }, [users.token])

  useEffect(() => {
    setAcount(users.phone)
    const cowSetting = companyInfo.cow_setting
    const settingMenus = cowSetting?.mobile_menus.filter(x => x.menu_state === 1)
    const originName = window.location.origin
    // eslint-disable-next-line no-unused-expressions
    settingMenus?.forEach(x => {
      if (x.menu_url.indexOf(originName) > -1) {
        x.innerRouter = true
        x.menu_url = x.menu_url.replace(originName, '')
      } else {
        x.innerRouter = false
      }
    })
    setMenus(settingMenus)
  }, [users.phone, companyInfo.cowSetting])
  async function navigationTo (path) {
    if (history.location.pathname === path) {
      if (onClose) onClose()
      return
    }

    if (!acount && (path === '/resume' || path === '/record')) {
      history.push('/login')
      return
    }
    history.push(path)
  }

  const handleLogOut = () => {
    container.saasService.logOut().then(() => {
      onClose()
      Toast.success({
        content: '已退出',
        icon: <Icon type='success' size={34} />,
        duration: 1
      })
      logout()
    })
  }
  return (
    <div className='mine'>
      <div className='mine-info'>
        <div className='mine-info__users'>
          <div className='mine-info__users-head'>
            <img src={defaultHead} alt='' />
          </div>
          {acount && <span className='mine-info__users-name'>{acount}</span>}
        </div>
        {!acount && (
          <Button
            onClick={() => {
              const redirect = encodeUrlSearch()
              const currentPath = window.location.pathname
              if (currentPath !== '/login') {
                history.push(`/login?redirect=${redirect}`)
              }
            }}
            className='mine-info__login'
            type='primary'
            fluid
            circle>
            登录
          </Button>
        )}
      </div>

      <div className='mine-cells'>
        {menus?.map(x => (
          <div
            className='mine-cell'
            role='presentation'
            onClick={() => {
              if (x.innerRouter) {
                navigationTo(`${x.menu_url || '/'}`)
              } else {
                window.location.href = x.menu_url
              }
            }}
            key={x.menu_name}>
            <div className='mine-cell__inner'>
              <span className='mine-cell__value'>{x.menu_name}</span>
              <Icon size='28' type='arrow' />
            </div>
          </div>
        ))}
        <div role='presentation' onClick={() => navigationTo('/resume')} className='mine-cell'>
          <div className='mine-cell__inner'>
            <span className='mine-cell__value'>我的简历</span>
            <Icon size='28' type='arrow' />
          </div>
        </div>
        <div role='presentation' className='mine-cell' onClick={() => navigationTo('/record')}>
          <div className='mine-cell__inner'>
            <span className='mine-cell__value'>投递记录</span>
            <Icon size='28' type='arrow' />
          </div>
        </div>
      </div>
      {isLogin && (
        <div
          className='back'
          onClick={() => {
            setVisible(true)
          }}>
          <span>退出登录</span>
        </div>
      )}

      <Modal
        wrapClassName='confirm-modal'
        okBtn
        cancelBtn
        maskStyle={{
          zIndex: 1302
        }}
        onOk={handleLogOut}
        onCancel={() => {
          setVisible(false)
        }}
        visible={visible}>
        <div className='logout-text'>真的要退出吗？</div>
      </Modal>
    </div>
  )
}
const mapStateToProps = state => ({ users: state.users, companyInfo: state.companyInfo })
const mapDispatchToProps = dispatch => ({
  logout: () => {
    dispatch(userLogout())
  }
})

Mine.defaultProps = {
  history: null
}
Mine.propTypes = {
  history: PropTypes.object,
  onClose: PropTypes.func,
  logout: PropTypes.func,
  users: PropTypes.object,
  companyInfo: PropTypes.object
}
export default connect(mapStateToProps, mapDispatchToProps)(Mine)
